<template>
  <div class="tabSwitchDiv">
    <template v-for="(item,index) in buttonNamesArr">
      <el-button :class="curIndex ===index?'selectButton':'noSelectButton'" class="tabButton"
                 @click="curBtnDeal(index)">{{ item }}
      </el-button>
    </template>
    <el-image v-if="delImg" class="tabDelImg" :src="require('../../assets/tab-del.png')"
              @click="delImgClick" style="cursor: pointer;"></el-image>
  </div>
</template>

<script>
/**
 * @Author: ygh
 * @Date: 2024/3/18 11:34
 * @Description:按钮切换公共组件
 */
export default {
  name: "tabSwitch",
  props: {
    'buttonNamesArr': {
      type: Array,
      required: true,
    },
    'delImg': {
      type: Boolean,
      default: false,
    },
  },
  mounted() {

  },
  data() {
    return {
      curIndex: 0,
    }
  },
  methods: {
    delImgClick() {
      this.curIndex=0;
      this.$emit('delImgDeal', '');
    },
    curBtnDeal(index) {
      this.curIndex = index;
      this.$emit('curTabButtonClickDeal', index);
    },
  }

}
</script>

<style scoped>
.tabDelImg {
  width: 3rem;
  height: 3rem;
  position: absolute;
  right: 4rem;
}

.tabButton {
  width: auto;
  height: 3.6rem;
  font-family: PingFang SC;
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  line-height: 3.6rem;
  border: solid 0rem #f4f4f4;
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.tabSwitchDiv {
  height: 6rem;
  background-color: #fbfbfb;
  display: flex;
  align-items: center;
}

.noSelectButton {
  background-color: #f7f7f7;
  color: #323232;
}

.selectButton {
  background-color: #53abfd;
  color: #ffffff;
}

</style>
